
import { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import NavbarContainer from "./navigation/NavbarContainer";
import Logo from "./navigation/Logo";
import NavigationLinks from "./navigation/NavigationLinks";
import UserMenu from "./navigation/UserMenu";
import UserAuthButtons from "./navigation/UserAuthButtons";
import MobileNav from "./navigation/MobileNav";
import { useIsMobile } from "@/hooks/use-mobile";

const Navbar = () => {
  const { user, isLoading } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  
  useEffect(() => {
    console.log("Navbar - Component mounted", {
      isUserAuthenticated: !!user,
      userEmail: user?.email || 'No email',
      isLoading,
      timestamp: new Date().toISOString()
    });
    
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [user, isLoading]);
  
  useEffect(() => {
    console.log("Navbar - Auth state updated", {
      isUserAuthenticated: !!user,
      userId: user?.id || 'No user ID',
      userEmail: user?.email || 'No email',
      isLoading,
      timestamp: new Date().toISOString()
    });
  }, [user, isLoading]);
  
  const isMobile = useIsMobile();

  console.log("Navbar - Rendering with auth state", {
    authStatus: user ? 'authenticated' : (isLoading ? 'loading' : 'unauthenticated'),
    isMobile,
    timestamp: new Date().toISOString()
  });
  
  return (
    <NavbarContainer scrolled={scrolled}>
      <div className="flex items-center gap-6">
        <Logo />
        {!isMobile && <NavigationLinks />}
      </div>

      <div className="flex items-center gap-2">
        {isLoading ? (
          <div className="h-9 w-20 animate-pulse rounded-md bg-muted"></div>
        ) : user ? (
          <UserMenu />
        ) : (
          <UserAuthButtons />
        )}
        <MobileNav />
      </div>
    </NavbarContainer>
  );
};

export default Navbar;
